<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="">
        <el-tab-pane label="基础信息" name="1"></el-tab-pane>
        <el-tab-pane label="账户明细" name="2"></el-tab-pane>
      </el-tabs>
      <div>
        <template v-if="activeName=='1'">
          <Title class="mt20">基础信息</Title>
          <el-descriptions title="" :column="3">
            <el-descriptions-item label="编号">{{info.id}}</el-descriptions-item>
            <el-descriptions-item label="城市公司名称">{{info.name}}</el-descriptions-item>
            <el-descriptions-item label="大区人数">{{info.areaNum}}</el-descriptions-item>
            <el-descriptions-item label="客户人数">{{info.customerNum}}</el-descriptions-item>
            <el-descriptions-item label="省市区">{{info.addrProvince}}-{{info.addrCity}}-{{info.addrArea}}</el-descriptions-item>
            <el-descriptions-item label="地址">{{info.addrDetail}}</el-descriptions-item>
            <!-- <el-descriptions-item label="打款账户">暂无字段</el-descriptions-item> -->
            <el-descriptions-item label="管辖区域">{{info.addrAreaNum}}</el-descriptions-item>
            <!-- <el-descriptions-item label="通商云ID">{{info.bizUserId}}</el-descriptions-item> -->
            <el-descriptions-item label="入驻时间">{{dayjs(info.checkInTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
            <el-descriptions-item label="修改时间">{{dayjs(info.operatedTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
            <el-descriptions-item label="状态">{{info.state?'启用':'禁用'}}</el-descriptions-item>
          </el-descriptions>
        </template>
        <template v-if="activeName=='2'">
          <Title class="mt20">账户明细</Title>
          <div>账户明细：</div>
          <el-table :data="list" class="mt20">
            <el-table-column label="编号" prop="id" align="center">
            </el-table-column>
            <!-- <el-table-column label="城市公司名称" prop="name" align="center" width="160" fixed>
              <template slot-scope="{row}">
                <div @click="handleShowDetail(row.id)">
                  <el-link type="primary">{{row.name}}</el-link>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column label="收款类型" prop="chargeName" align="center">
              <template slot-scope="{row}">
                <div>
                  {{row.commissionSource | setType}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="金额变动" prop="" align="center" width="160">
              <template slot-scope="{row}">
                <div>
                  {{row.type?'+':'-'}}{{row.money}}
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="当前余额" prop="customerNum" align="center" /> -->
            <el-table-column label="变动时间" prop="createdTime" sortable align="center" width="200" />
          </el-table>
          <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
        </template>
      </div>
    </el-card>
  </div>
</template>

<script>
import cityCompanyApi from '@/api/sys/cityCompany'
export default {
  props: ['rowId'],
  data() {
    return {
      activeName: '1',
      info: {
        customer: {},
        customerUserPO: {},
        customerLevel: {},
        customerCertificates: {},
        line: {},
        technicianInfo: {},
        userWallet: {}
      },
      // listLoading: true,
      list: [],
      query: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      options: [],
      customerLine: '',
      activeName: '1',
    }
  },
  async created() {
    // await this.getBusinessStanding()
    await this.getDetail()
    // this.getBusinessStanding()
    this.doQueryList({
      pageNo: 1
    })
    // this.handleShow()
    // if (this.technicalState) this.getShareData()
  },
  filters: {
    setType(val) {
      switch (val) {
        case 4:
          return "学费";
        case 3:
          return "充值";
        case 2:
          return "秒杀订单";
        case 1:
          return "订货订单";
        default:
          return val;
      }
    }
  },
  methods: {
    async getDetail() {
      const {
        data
      } = await cityCompanyApi.fetchById(this.rowId)
      // const {data}=await clientListApi.fetchById(91)
      this.info = data
      console.log('详情: ', this.info, data);
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    // /**
    //  * 执行列表查询
    //  */
    async doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = {
        cityCompanyId: this.rowId,
        ...this.query
      }
      const {
        data
      } = await cityCompanyApi.getAccount(query)
      this.list = data.list
      console.log('列表: ', data);
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.options = data
        console.log('客户身份: ', data);
      })
    },
  }

}
</script>

<style lang="scss" scoped>
a:hover {
  color: #60b7dc;
}

.round-active {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #008e28;
}

.round {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #979797;
}

.label-box {
  background: #1596cd1a;
  padding: 2px;
  border-radius: 2px;
  color: #1596cd;
}

.label-boxs {
  background: #c8ab0e1a;
  padding: 2px 4px;
  border-radius: 2px;
  color: #c8ab0e;
}

.step-box {
  width: 160px;
  height: 44px;
  margin-right: 10px;

  ::v-deep .el-image {
    width: 160px;
    height: 44px;
  }

  div {
    left: 0;
    top: 0;
  }
}

::v-deep.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 14px;
}
</style>
